import { reactive, toRefs, computed } from 'vue'

const messages = {
  de: {
    uploadTipsTitle: 'Tipps für ein perfektes Ergebnis',
    uploadQualityTitle: 'Bildqualität',
    uploadQualityBody: 'Du solltest bei der Auswahl deines Fotos Wert auf eine hervorragende Bildqualität legen. Das Bild sollte eine hohe Auflösung aufweisen und keinesfalls verschwommen sein.',
    uploadLightingTitle: 'Belichtung',
    uploadLightingBody: 'Achte darauf, dass dein Foto ausreichend beleuchtet ist. Bilder, die zu dunkel sind, beeinträchtigen bedauerlicherweise das Ergebnis.',
    uploadSizeTitle: 'Auswahl der richtigen Größe',
    uploadSizeBody: 'Kleine Größen wie 30x45cm sind ideal für Nahaufnahmen geeignet. Bei Fotos mit mehreren Personen empfehlen wir größere Formate ab 40x60 cm. Damit alles perfekt passt, legen wir dir unseren Profi-Datencheck ans Herz.',
    uploadPhoto: 'Foto hochladen',
    backToShop: 'Zurück zum Shop',
    back: 'Zurück',
    priceInfo: 'Alle Preise inkl. MwSt. zzgl. Versand',
    next: 'Weiter',
    edit: 'Bearbeiten',
    extras: 'Extras',
    extrasTitle: 'Füge Extras zu deinem Bild hinzu',
    serviceTitle: 'Unser Service für Dich',
    preview: 'Vorschau',
    previewLower: 'vorschau',
    addMorePhoto: 'Fertig & weiteres Foto hochladen',
    addToCart: 'Fertig & in den Warenkorb',
    uploadError: 'Entschuldigen Sie, etwas ist schief gelaufen. Bitte wenden Sie sich an das Picmondoo-Team.',
    uploadErrorRetry: 'Entschuldigen Sie, etwas ist schiefgelaufen. Bitte wenden Sie sich an das Picmondoo-Team.',
    bestResult: 'Schönstes Ergebnis',
    bestseller: 'Bestseller',
    amount: 'Menge',
    colorSingular: 'Farbe',
    colorPlural: 'Farben',
    free: 'Gratis!',
    new: 'Neu!',
    landscapePortrait: 'Quer/Hochformat',
    triptych: '3-Teilig',
    fivePart: '5-Teilig',
    paintByNumbers: 'Malen nach Zahlen',
    diamondPainting: 'Diamond Painting',
    sizeAndFormat: 'Größe und Format',
    size: 'Größe',
    stoneShape: 'Steinform',
    frame: 'Rahmen',
    color: 'Farbe',
    invalidFormat: 'Ungültiges Format',
    productView: 'Produktansicht',
    wallView: 'Wandansicht',
    frameWithout: 'Ohne Keilrahmen (Nur Leinwand)',
    frameWith: 'Mit Keilrahmen (bereits bespannt)',
    max24Colors: 'max. 24 Farben',
    max36Colors: 'max. 36 Farben',
    zoomOut: 'Kleiner zoomen',
    zoomIn: 'Größer zoomen',
    rotate: 'Drehen',
    flip: 'Spiegeln',
    fitBox: 'An Box anpassen',
    cancel: 'Abbrechen',
    apply: 'Anwenden',
    restart: 'Neustart',
    editImage: 'Bearbeiten',
    previewAction: 'Vorschau',
    squareFormat: 'Quadratisch',
    stoneRound: 'Rund',
    stoneSquare: 'Quadratisch'
  },
  en: {
    uploadTipsTitle: 'Tips for a perfect result',
    uploadQualityTitle: 'Image quality',
    uploadQualityBody: 'Choose a photo with excellent resolution. It should be sharp and never blurry.',
    uploadLightingTitle: 'Lighting',
    uploadLightingBody: 'Make sure your photo is well lit. Images that are too dark will unfortunately hurt the result.',
    uploadSizeTitle: 'Choosing the right size',
    uploadSizeBody: 'Small sizes like 30x45cm are ideal for close-ups. For photos with several people, we recommend formats from 40x60cm. For the best fit we recommend our pro data check.',
    uploadPhoto: 'Upload photo',
    backToShop: 'Back to shop',
    back: 'Back',
    priceInfo: 'All prices incl. VAT plus shipping',
    next: 'Continue',
    edit: 'Edit',
    extras: 'Extras',
    extrasTitle: 'Add extras to your picture',
    serviceTitle: 'Our service for you',
    preview: 'Preview',
    previewLower: 'preview',
    addMorePhoto: 'Finish & upload another photo',
    addToCart: 'Finish & add to cart',
    uploadError: 'Sorry, something went wrong. Please contact the Picmondoo team.',
    uploadErrorRetry: 'Sorry, something went wrong. Please contact the Picmondoo team.',
    bestResult: 'Best result',
    bestseller: 'Bestseller',
    amount: 'Quantity',
    colorSingular: 'color',
    colorPlural: 'colors',
    free: 'Free!',
    new: 'New!',
    landscapePortrait: 'Landscape/Portrait',
    triptych: 'Triptych',
    fivePart: 'Five-piece',
    paintByNumbers: 'Painting by numbers',
    diamondPainting: 'Diamond painting',
    sizeAndFormat: 'Size and format',
    size: 'Size',
    stoneShape: 'Stone shape',
    frame: 'Frame',
    color: 'Color',
    invalidFormat: 'Invalid format',
    productView: 'Product view',
    wallView: 'Wall view',
    frameWithout: 'Without stretcher frame (canvas only)',
    frameWith: 'With stretcher frame (pre-stretched)',
    max24Colors: 'max. 24 colors',
    max36Colors: 'max. 36 colors',
    zoomOut: 'Zoom out',
    zoomIn: 'Zoom in',
    rotate: 'Rotate',
    flip: 'Flip',
    fitBox: 'Fit to box',
    cancel: 'Cancel',
    apply: 'Apply',
    restart: 'Restart',
    editImage: 'Edit',
    previewAction: 'Preview',
    squareFormat: 'Square',
    stoneRound: 'Round',
    stoneSquare: 'Square'
  },
  fr: {
    uploadTipsTitle: 'Conseils pour un résultat parfait',
    uploadQualityTitle: "Qualité de l'image",
    uploadQualityBody: "Choisissez une photo avec une excellente résolution. Elle doit être nette et non floue.",
    uploadLightingTitle: 'Éclairage',
    uploadLightingBody: 'Assurez-vous que votre photo est suffisamment éclairée. Des images trop sombres dégradent le résultat final.',
    uploadSizeTitle: 'Choisir la bonne taille',
    uploadSizeBody: 'Les petits formats comme 30x45cm sont idéaux pour les gros plans. Pour les photos avec plusieurs personnes, nous recommandons des formats à partir de 40x60 cm. Pour un résultat parfait, nous conseillons notre contrôle de données professionnel.',
    uploadPhoto: 'Télécharger une photo',
    backToShop: 'Retour à la boutique',
    back: 'Retour',
    priceInfo: 'Tous les prix TTC, hors frais de port',
    next: 'Continuer',
    edit: 'Modifier',
    extras: 'Extras',
    extrasTitle: 'Ajoutez des extras à votre image',
    serviceTitle: 'Notre service pour vous',
    preview: 'Aperçu',
    previewLower: 'aperçu',
    addMorePhoto: 'Terminer et ajouter une autre photo',
    addToCart: 'Terminer et ajouter au panier',
    uploadError: "Désolé, une erreur est survenue. Merci de contacter l'équipe Picmondoo.",
    uploadErrorRetry: "Désolé, une erreur est survenue. Merci de contacter l'équipe Picmondoo.",
    bestResult: 'Meilleur résultat',
    bestseller: 'Meilleure vente',
    amount: 'Quantité',
    colorSingular: 'couleur',
    colorPlural: 'couleurs',
    free: 'Gratuit !',
    new: 'Nouveau !',
    landscapePortrait: 'Paysage/Portrait',
    triptych: '3 panneaux',
    fivePart: '5 panneaux',
    paintByNumbers: 'Peinture par numéros',
    diamondPainting: 'Diamond painting',
    sizeAndFormat: 'Taille et format',
    size: 'Taille',
    stoneShape: 'Forme des pierres',
    frame: 'Cadre',
    color: 'Couleur',
    invalidFormat: 'Format invalide',
    productView: 'Vue produit',
    wallView: 'Vue murale',
    frameWithout: 'Sans châssis (toile uniquement)',
    frameWith: 'Avec châssis (déjà tendu)',
    max24Colors: 'max. 24 couleurs',
    max36Colors: 'max. 36 couleurs',
    zoomOut: 'Zoom arrière',
    zoomIn: 'Zoom avant',
    rotate: 'Pivoter',
    flip: 'Miroir',
    fitBox: 'Ajuster à la boîte',
    cancel: 'Annuler',
    apply: 'Appliquer',
    restart: 'Redémarrer',
    editImage: 'Modifier',
    previewAction: 'Aperçu',
    squareFormat: 'Carré',
    stoneRound: 'Rond',
    stoneSquare: 'Carré'
  }
}

const state = reactive({
  locale: 'de'
})

const supportedLocales = Object.keys(messages)

const translate = (key) => messages[state.locale]?.[key] ?? messages.de?.[key] ?? key

const setLocale = (newLocale) => {
  if (supportedLocales.includes(newLocale)) {
    state.locale = newLocale
  }
}

export function useI18n() {
  const locale = computed(() => state.locale)
  return {
    ...toRefs(state),
    locale,
    t: translate,
    setLocale,
    availableLocales: supportedLocales
  }
}

export default {
  install(app) {
    app.config.globalProperties.$t = translate
    app.config.globalProperties.$locale = state
    app.config.globalProperties.$setLocale = setLocale
    app.provide('t', translate)
    app.provide('localeState', state)
    app.provide('setLocale', setLocale)
  }
}
